"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../contexts/LanguageContext");
var _utils = require("./utils");
var _excluded = ["error", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var fieldBlur = function fieldBlur(password, confirm) {
  return password === confirm ? password : false;
};
var Password = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Password, _PureComponent);
  var _super = _createSuper(Password);
  function Password(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Password);
    _this = _super.call(this, props);
    _this.state = {
      password: '',
      confirm: ''
    };
    return _this;
  }
  (0, _createClass2["default"])(Password, [{
    key: "onChange",
    value: function onChange() {
      var _this$state = this.state,
        password = _this$state.password,
        confirm = _this$state.confirm;
      if (password === confirm) {
        this.props.input.onChange(password);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        _this$props$meta = _this$props.meta,
        _this$props$meta$asyn = _this$props$meta.asyncValidating,
        asyncValidating = _this$props$meta$asyn === void 0 ? false : _this$props$meta$asyn,
        active = _this$props$meta.active,
        valid = _this$props$meta.valid,
        touched = _this$props$meta.touched,
        _this$props$input = _this$props.input,
        onFocus = _this$props$input.onFocus,
        _onBlur = _this$props$input.onBlur,
        t = _this$props.t;
      var _this$state2 = this.state,
        password = _this$state2.password,
        confirm = _this$state2.confirm;
      var _util_commonInputPara = (0, _utils.util_commonInputParamters)(this.props),
        _util_commonInputPara2 = _util_commonInputPara.error,
        error = _util_commonInputPara2 === void 0 ? '' : _util_commonInputPara2,
        onChange = _util_commonInputPara.onChange,
        fieldProps = (0, _objectWithoutProperties2["default"])(_util_commonInputPara, _excluded);
      var passwordPlaceholder = t('components.password.password');
      var confirmPlaceholder = "".concat(t('components.password.confirm'), " ").concat(t('components.password.password'));
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({}, fieldProps, {
        id: "t-password",
        value: password,
        onChange: function onChange(_ref) {
          var password = _ref.target.value;
          return _this2.setState({
            password: password
          }, function () {
            return _this2.onChange();
          });
        },
        placeholder: this.props.config.placeholder || passwordPlaceholder,
        type: "password",
        onBlur: function onBlur() {
          if (password !== '' && confirm !== '') {
            return _onBlur(fieldBlur(password, confirm));
          }
        },
        onFocus: onFocus
      })), /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({}, fieldProps, {
        id: "t-passwordConfirm",
        value: confirm,
        label: "",
        onChange: function onChange(_ref2) {
          var confirm = _ref2.target.value;
          return _this2.setState({
            confirm: confirm
          }, function () {
            return _this2.onChange();
          });
        },
        placeholder: this.props.config.confirmPlaceholder || confirmPlaceholder,
        type: "password",
        onBlur: function onBlur() {
          if (password !== '' && confirm !== '') {
            return _onBlur(fieldBlur(password, confirm));
          }
        },
        onFocus: onFocus
      })), asyncValidating && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        id: 't-passwordConfirm-message',
        style: {
          color: 'gray'
        }
      }, "".concat(t('components.password.validating'), " ").concat(t('components.password.password')), "..."), !asyncValidating && !active && touched && valid && password !== '' && confirm !== '' && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        id: 't-passwordConfirm-message',
        style: {
          color: 'green'
        }
      }, "\u2713", ' ', "".concat(t('components.password.password'), " ").concat(t('components.password.ok'))), !asyncValidating && error !== '' && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
        id: 't-passwordConfirm-message'
      }, error));
    }
  }]);
  return Password;
}(_react.PureComponent);
var PasswordWithTranslation = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(Password);
PasswordWithTranslation.handlesErrorDisplay = true;
var _default = exports["default"] = PasswordWithTranslation;